import { createActionGroup, emptyProps, props } from '@ngrx/store'
import {
    IProposalData,
    IContact,
    IEmailTemplate,
    IDocumentOption,
    TEmailField,
    TEmailFieldValueUnion,
} from '../../models/email-proposal.models'

export const EmailProposalActions = createActionGroup({
    source: 'Email Proposal',
    events: {
        'Load Proposal Data': props<{ proposalId: string }>(),
        'Load Proposal Data Success': props<{ proposalData: IProposalData }>(),
        'Load Proposal Data Failure': props<{ error: string }>(),

        'Load Documents': props<{ proposalId: string }>(),
        'Load Documents Success': props<{ documents: IDocumentOption[] }>(),
        'Update Documents': props<{ documents: IDocumentOption[] }>(),
        'Remove Attachment': props<{ fileId: string }>(),

        'Load Email Templates': emptyProps(),
        'Load Email Templates Success': props<{ templates: IEmailTemplate[] }>(),

        'Update Email Field': props<{ field: TEmailField; value: TEmailFieldValueUnion }>(),
        'Add Contact': props<{ contact: IContact }>(),
        'Remove Contact': props<{ contactId: string }>(),
        'Generate Password': emptyProps(),
        'Update Confirmation Status': props<{ checked: boolean }>(),

        'Show Preview': emptyProps(),
        'Hide Preview': emptyProps(),
        'Show Add Contact Dialog': emptyProps(),
        'Hide Add Contact Dialog': emptyProps(),

        'Send Email': emptyProps(),
        'Send Email Success': emptyProps(),
        'Send Email Failure': props<{ error: string }>(),
    },
})
